import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
export var ENV_TYPE;
(function (ENV_TYPE) {
    ENV_TYPE["MT_APP"] = "MT_APP";
    // 美团App
    ENV_TYPE["DP_APP"] = "DP_APP";
    // 点评App  
    ENV_TYPE["MT_MINI"] = "MT_MINI";
    // 美团小程序
    ENV_TYPE["DP_MINI"] = "DP_MINI";
    // 点评小程序
    ENV_TYPE["HOTEL_MINI"] = "HOTEL_MINI";
    // 美团酒店小程序
    ENV_TYPE["FALLBACK"] = "FALLBACK"; // 兜底环境（包含其他所有环境）
})(ENV_TYPE || (ENV_TYPE = {}));
export const getCurrentEnvType = () => {
    const platformType = getPlatformType();
    // 美团App
    if ([PlatformType.mtApp, PlatformType.mtAppWebView].includes(platformType)) {
        return ENV_TYPE.MT_APP;
    }
    // 点评App
    if ([PlatformType.dpApp, PlatformType.dpAppWebView].includes(platformType)) {
        return ENV_TYPE.DP_APP;
    }
    // 美团小程序
    if (platformType === PlatformType.mtMinaWebview) {
        return ENV_TYPE.MT_MINI;
    }
    // 点评小程序
    if (platformType === PlatformType.dpMinaWebview) {
        return ENV_TYPE.DP_MINI;
    }
    // 美团酒店小程序
    if (platformType === PlatformType.mtHotelMinaWebview) {
        return ENV_TYPE.HOTEL_MINI;
    }
    // 其他所有环境（包括门票小程序、民宿App、PC端等）都走兜底
    return ENV_TYPE.FALLBACK;
};
export const getJumpUrlByEnv = (jumpConfig, fallbackUrl = '') => {
    // 如果不是URL跳转类型，返回空字符串
    if ((jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.jumpType) !== 'url') {
        return '';
    }
    const envType = getCurrentEnvType();
    let selectedUrl = '';
    switch (envType) {
        case ENV_TYPE.MT_APP:
            selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.mtAppUrl) || '';
            break;
        case ENV_TYPE.DP_APP:
            selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.dpAppUrl) || '';
            break;
        case ENV_TYPE.MT_MINI:
            selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.mtMiniUrl) || '';
            break;
        case ENV_TYPE.DP_MINI:
            selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.dpMiniUrl) || '';
            break;
        case ENV_TYPE.HOTEL_MINI:
            selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.hotelMiniUrl) || '';
            break;
        default:
            selectedUrl = '';
    }
    // 如果当前环境没有配置URL，再考虑兜底方案
    if (!selectedUrl) {
        selectedUrl = (jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.fallbackUrl) || fallbackUrl || '';
    }
    return selectedUrl;
};
